<script>
  import 'destyle.css'
  import ItemList from './ItemList.svelte'
  import Logo from './Logo.svelte'
  let clients = [
    { name: 'iContract', url: 'https://www.icontract.co.uk' },
    { name: 'Moola', url: 'https://moo.la' },
    { name: 'Buzzbikes', url: 'https://buzzbike.cc' },
    { name: 'Debut', url: 'http://debut.careers' },
    { name: 'Hypit', url: 'https://itunes.apple.com/gb/app/hypit-discover-collect-share-places-you-love/id934808090?mt=8' },
  ]
  let ventures = [
    { name: 'Foodchain', url: 'https://www.joinfoodchain.com' },
    { name: 'domore', url: 'https://www.domore.network' },
  ]
  let partners = [
    { name: 'Jez', url: 'https://github.com/jezallan' },
    { name: 'Alex', url: 'https://github.com/alexjg' },
    { name: 'Nassar', url: 'https://twitter.com/nassarhayat' },
  ]
  let collaborators = [
    { name: 'Oykun', url: 'http://oykun.com' },
    { name: 'Julian', url: 'https://reactrocket.com' },
    { name: 'Mike', url: 'https://twitter.com/mikeybee77' },
    { name: 'Hermione', url: 'https://twitter.com/hermioneway' },
    { name: 'Rosie', url: 'http://rosiemanning.com' },
  ]
  let posts = [
    { name: `Don't mine short- term opportunities; Create the future`, url: 'https://journal.makerlabs.co.uk/grind-your-way-to-a-high-scale-product-company-5b25a94374ec' },
    { name: 'Lean startup — 5 years on…', url: 'https://journal.makerlabs.co.uk/lean-startup-5-years-on-d3c78b57335a' },
    { name: 'How to launch a consumer app like a BOSS', url: 'https://journal.makerlabs.co.uk/how-to-launch-a-consumer-app-like-a-boss-80c48d25a3c2' },
  ]
</script>

<main>
  <a href='/'>
    <Logo/>
  </a>
  <div class='maker-labs'>
    <h1>maker labs</h1>
  </div>
  <section>
    <h2>Thesis</h2>
    <p>We believe digital platforms have the power to unlock productivity and dramatically reshape industries. We work with industry leaders to build game changing technology platforms.</p>
  </section>
  <article>
    <section>
      <h2>Recent</h2>
      <ItemList items={clients} />
    </section>
    <section>
      <h2>Active Ventures</h2>
      <ItemList items={ventures} />
    </section>
  </article>
  <article>
    <section>
      <h2>Partners</h2>
      <ItemList items={partners} />
    </section>
    <section>
      <h2>Collaborators</h2>
      <ItemList items={collaborators} />
    </section>
  </article>
  <section>
    <h2>Posts</h2>
    <ItemList items={posts} />
  </section>
  <footer>
    <a href='mailto:hello@makerlabs.co.uk' rel='noopener noreferrer' target='_blank'>Speak privately</a>
    <a href='https://www.twitter.com/makerlabshq' rel='noopener noreferrer' target='_blank'>Speak publicly</a>
  </footer>
</main>

<style>
@custom-media --media-s screen and (min-width: 700px);

:global(:root) {
  --font-stack: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  --black: #17181D;
  --red: #E53D21;

}

:global(body) {
  font-family: var(--font-stack);
}

main {
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
  justify-items: start;
  min-height: 100%;
  max-width: 660px;
  width: 100%;
  padding: 0 2rem;
  margin: 2rem auto;

  @media (--media-s) {
    margin: 8rem auto;
    padding: 0;
  }
}

h1 {
  color: var(--black);
  text-align: left;
  font-size: 4rem;
  @media (--media-s) {
    font-size: 6rem;
  }
}

.maker-labs {
  background: linear-gradient(to bottom, white 70%, var(--red) 30%);
  margin: 2rem 0;
}

article {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  grid-gap: 1rem;
  @media (--media-s) {
    grid-template-columns: 1fr 2fr;
  }
}

section {
  margin: 1rem 0;
}

footer {
  width: 100%;
  padding: 4rem 0;

  & > a {
    margin-right: 1rem;
    border-bottom: 3px solid transparent;
    transition: border-color 0.2s;
    &:hover {
      border-color: var(--red);
    }
  }
}

</style>
